import { InjectionToken } from '@angular/core';

export interface IInitializable {
  init(): void | Promise<void>;
}

export const INITIALIZABLE_SERVICES = new InjectionToken<IInitializable[]>('INITIALIZABLE_SERVICES');
